import ExtensibilityContext from 'owa-service/lib/contract/ExtensibilityContext';
import { Addin, IEnabledAddinCommands, getExtensibilityState } from 'owa-addins-store';
import { AddinCommandSurfaceItem } from 'owa-addins-types';
import { computed, IComputedValue } from 'mobx';
import { createAddinCommandSurfaceActions } from './contextMenuDataUtils';
import { ExtensibilityModeEnum } from 'owa-addins-types';

type ComputedSurfaceItems = { [key: string]: IComputedValue<AddinCommandSurfaceItem> };

const computedSurfaceItems: ComputedSurfaceItems = {};

export function observeAddinCommandSurfaceItems(
    mode: ExtensibilityModeEnum,
    isSharedItem?: boolean
): IComputedValue<AddinCommandSurfaceItem> {
    isSharedItem = !!isSharedItem;
    const key = getSurfaceItemsKey(mode, isSharedItem);

    if (!computedSurfaceItems[key]) {
        computedSurfaceItems[key] = computed(() => {
            const context = getExtensibilityState().Context;
            const enabledAddinCommands = getExtensibilityState().EnabledAddinCommands;

            if (!enabledAddinCommands) {
                return null;
            }
            return getAddinCommandSurfaceItems(mode, enabledAddinCommands, context, isSharedItem);
        });
    }
    return computedSurfaceItems[key];
}

export function getAddinCommandSurfaceItems(
    mode: ExtensibilityModeEnum,
    enabledAddinCommands: IEnabledAddinCommands,
    context: ExtensibilityContext,
    isSharedItem: boolean
) {
    if (context && enabledAddinCommands.isInitialized) {
        const enabledAddins: Addin[] = enabledAddinCommands.getExtensionPoint(mode, isSharedItem);
        return createAddinCommandSurfaceActions(enabledAddins);
    }
    return null;
}

function getSurfaceItemsKey(mode: number, isSharedItem: boolean): string {
    return mode + '_' + isSharedItem;
}
